import { IUpdateRawQueryList } from '@models/Update.model';
import { UpdatesCompletedQuery } from './UpdatesCompleted.query';

interface IUpdatesCompleted {
  data: IUpdateRawQueryList[];
  isLoading: boolean;
  isError: boolean;
  hasMore?: boolean;
  loadMore: () => void;
}

const UpdatesCompleted = ({
  data,
  isLoading,
  isError,
  loadMore,
  hasMore,
}: IUpdatesCompleted) => {
  return (
    <UpdatesCompletedQuery
      data={data}
      isLoading={isLoading}
      isError={isError}
      loadMore={loadMore}
      hasMore={hasMore}
    />
  );
};

export { UpdatesCompleted };
